import axios from 'axios';
import _ from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import settings from '../../settings';
import {getToken} from '../../storage/sessionStorage';
import { showAlert } from '../../actions/generic/alertActions';
import store from '../../stores/store';

const addAuth = function (config) {
	const token = getToken();
	if (token) config.headers.Authorization = `Bearer ${token}`; //Currently we're just adding a token to each call. We can refine it to only add auth token to certain calls if need be...
	return config;
};

const authReject = function (error) {
	return Promise.reject (error);
};

const handleResponse = (response) => {
	return response;
}

const handleError = (error) => {

	if (!_.isEmpty(error.response) && !_.isEmpty(error.response.data) && !_.isEmpty(error.response.data.error) && !_.isEmpty(error.response.config)){
	  // console.log('baseWs got error with status ' + error.response.status + ' and message: ' + error.response.data.error.message);
	  // console.log('baseWs error was with request to ' + error.response.config.url + ' and data: ' + error.response.config.data)
	  // console.log(error.response)
	  //console.log(error.response);
	  store.dispatch(
		showAlert({
		  type: 'danger',
		  title: error.response.data.error.message,
		  content: error.response.data.error.details,
		  //showCancel: true,
		})
	  );
	}
	else {
	  console.log('this is the exception catch error!')
	  console.log(error)
	  store.dispatch(
		showAlert({
		  type: 'danger',
		  title: 'Error',
		  content: 'An unexpected error occurred'
		  //showCancel: true,
		})
	  );
	}
  
	// console.log('baseWs Error:');
	// console.log(error);
	// console.log('baseWs Error Response:');
	// console.log(error.response);
	return Promise.resolve({ error });
  }

var defaultAxiosInstance = axios.create({
    baseURL: settings.serverHost,
    timeout: 10000,
    withCredentials: false
});

var noTimeoutAxiosInstance = axios.create({
    baseURL: settings.serverHost,
    timeout: 0,
    withCredentials: false
});

defaultAxiosInstance.interceptors.request.use (addAuth,authReject);
defaultAxiosInstance.interceptors.response.use(handleResponse, handleError);

noTimeoutAxiosInstance.interceptors.request.use (addAuth,authReject);
noTimeoutAxiosInstance.interceptors.response.use(handleResponse, handleError);

export default defaultAxiosInstance;

export const noTimeoutWs = noTimeoutAxiosInstance;

export const noAuthGetDownloadRequest = (url) => {
	return axios.get(url,{
		responseType : "arraybuffer"
	});
}